



















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "card",
})
export default class Card extends Vue {
    @Prop({ default: false })
    loading: boolean;

    @Prop()
    title: string;

    @Prop()
    subtitle: string;
}
